import apiRequest from "./apiConfig";

const BASE_URL = "https://uatedsbrapi.zenplus.in/private-attendance/api/v1";

export function getLiveAttendanceEmployees(query) {
  return apiRequest({
    method: "get",
    url: `${BASE_URL}/employee`,
    query,
    timeout: 15000,
  });
}

export function markEmployeeLogin({ employeeReferenceId, dateTime }) {
  return apiRequest({
    method: "post",
    url: `${BASE_URL}/attendance/mark/simple`,
    query: {
      employeeReferenceId,
      dateTime,
      swipeInOrSwipeOut: "SWIPE_IN",
    },
  });
}
